/* eslint-disable @typescript-eslint/ban-types */
/**
 * Vertical Tab Bar Container Component
 * @module patterns/components/containers/vertical-tab-bar-container
 */
import { isMobile } from '@root/src/framework/scripts/helpers/browser/media-query';
import { scrollIntoView, scrollToCoord } from '@root/src/framework/scripts/utils/scroll';
import { updateLinkClasses } from '@root/src/framework/scripts/utils/tiny-mce-links';
import { App } from '~/app';

function findParentWithFloatingIsland(element: HTMLElement | null): HTMLElement | null {
    if (!element) {
	  return null;
    }
  
    if (element.classList.contains('floating-island')) {
	  return element;
    }
  
    return findParentWithFloatingIsland(element.parentElement);
}
  

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Vertical Tab Bar Container Component');

    const listeners: Array<[Document | Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            const verticalTabs = document.querySelectorAll<HTMLElement>('.vertical-tabs');
            const tabWrappers: NodeListOf<HTMLElement> = document.querySelectorAll('.vertical-tab-buttons');
			
            let isStuck = false;

            tabWrappers.forEach((tabWrapper: HTMLElement) => {
                window.addEventListener('scroll', () => {
                    const tabWrapperBoundingRect = tabWrapper.getBoundingClientRect();
                    const tabWrapperTopOffset = tabWrapperBoundingRect.y;
                    const screenSize = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                    if (!isStuck && tabWrapperTopOffset <= 150 && screenSize >768 && findParentWithFloatingIsland(tabWrapper)) {
                        isStuck = true;
                        tabWrapper.classList.add('stuck');
                    } else if (isStuck && tabWrapperTopOffset > 150) {
                        isStuck = false;
                        tabWrapper.classList.remove('stuck');
                    }
                });
            })
			
            for (const verticalTab of verticalTabs) {
                updateLinkClasses(verticalTab)
                // eslint-disable-next-line @typescript-eslint/no-loop-func
                const scrollToContentTop = (event: Event) => {
                    if (event.target instanceof Element) {
                        if (isMobile()) {
                            // On mobile the tabs stack on top of the content, thus the go-to point changes
                            const tabWrapper = verticalTab?.querySelector<HTMLElement>('.vertical-tab-buttons');

                            if (!tabWrapper) return;

                            // Scroll to bottom of vertical tab buttons
                            const rect = tabWrapper.getBoundingClientRect();
                            const top = rect.bottom + window.scrollY;
                            scrollToCoord(top);
                        } else {
                            // "auto" used due to issues with the delay when content is faded into view
                            // "auto" used due to issues with the delay when content is faded into view
                            const headerOffset = 25;
                            const elementPosition = verticalTab?.getBoundingClientRect();
                            const topOffset = elementPosition?.top ?? 0;
                            const offsetPosition = topOffset + window.pageYOffset - headerOffset;

                            window.scrollTo({
                                top: offsetPosition,
                                behavior: 'auto',
                            });
                        }
                    }
                };

                const tabs = verticalTab.querySelectorAll<HTMLElement>('.nav-link');
                for (const tab of tabs) {
                    tab.addEventListener('click', scrollToContentTop);
                    listeners.push([tab, 'click', scrollToContentTop]);
                }
            }
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Vertical Tab Bar Container Component', error);
        });


    return function destroyVerticalScrollCarousel() {
        for (const [element, event, listener] of listeners) {
            element.removeEventListener(event, listener);
        }

        app.logger.debug('[DXA] Vertical Tab Bar Container Component destroyed');
    };
};
